export const Tab = {
    Unknown: 'Unknown',
    Orders: 'Orders',
    Referrals: 'Referrals',
    ClinicalFeedback: 'ClinicalFeedback',
    ImagingRequests: 'ImagingRequests',
    DemandManagement: 'DemandManagement'
};
export type Tab = typeof Tab[keyof typeof Tab];
